import React, { useState } from 'react';
import { FormFieldProps } from '../../FormTypes';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Typography } from '@mui/material';
import moment from 'moment';
import FormField from '../../FormField';
import { useUserContext } from 'UserContext';
import { useFieldValidation } from '../../FormHook';
import ErrorText from '../../ErrorText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';
import { Colors } from 'library';

interface JobDatePickerProps {
    jobDate: FormFieldProps<moment.Moment | null>;
    minDate?: moment.Moment | Date;
    additionalErrorState?: boolean;
    errorMessage?: string;
    dependency?: Array<any>;
    title?: string;
    id?: string;
    maxDate?: moment.Moment | Date;
}

export default function JobDatePicker({
    jobDate,
    additionalErrorState = true,
    dependency = [jobDate.value],
    errorMessage = 'This Date is not valid!',
    title,
    id,
    maxDate,
}: JobDatePickerProps) {
    const { value, setValue, isValid } = jobDate;
    const { user } = useUserContext();
    const [showErrors, setShowErrors] = useState(false);

    const today = moment();
    const tomorrow = moment().add(1, 'days');
    const payment_setup = !!user?.payment_information && user?.payment_information?.length > 0;
    const minDate = payment_setup ? today : tomorrow;

    useFieldValidation(jobDate, additionalErrorState, dependency);

    function onSelectDate(selectedDate: moment.Moment | Date | null) {
        setShowErrors(true);
        setValue(selectedDate ? moment(selectedDate) : null);
    }

    return (
        <FormField title={title}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                    format="MM/DD/YYYY"
                    value={value}
                    onChange={onSelectDate}
                    openTo="day"
                    minDate={minDate}
                    maxDate={maxDate ? moment(maxDate) : undefined}
                    slots={{
                        openPickerIcon: () => (
                            <FontAwesomeIcon icon={faCalendarCheck} style={{ color: Colors.darkNavy }} />
                        ),
                    }}
                    slotProps={{
                        textField: {
                            variant: 'standard',
                            style: { width: '100%' },
                            id: `job-date-picker-${id}`,
                        },
                    }}
                />
            </LocalizationProvider>
            {!payment_setup ? (
                <Typography style={{ fontSize: 12 }}>
                    Same day appointments unavailable until payment is set up.
                </Typography>
            ) : null}
            {!isValid && showErrors ? <ErrorText>{errorMessage}</ErrorText> : ''}
        </FormField>
    );
}
